import {IDisposable} from '@mintdata/mint-kit/api/resources/IDisposable';
import {PopupDismissedReason} from '@mintdata/mint-kit/impl/components/popover/PopupDismissedReason';
import {PopupStackListener} from '@mintdata/mint-kit/impl/components/popover/PopupManager';
import {PopupItem, PopupItemWithIndex} from '@mintdata/mint-kit/impl/components/popover/PopupState';
import * as React from 'react';

export enum PopupKind
{
    Window,
    Popover
}

export type PopupId = string;
export type PopupGroup = string;

export type OnPopupDismissedFn = (reason?:PopupDismissedReason) => (void);
export type ReadIsVisibleFn = () => (boolean);
export type WriteIsVisibleFn = (isVisible:boolean) => (void);
export type ReadWriteIsVisibleFn = (isVisible?:boolean) => (void | boolean);

export type PopupSource = HTMLElement | ClientRect;

export interface IPopupProps
{
    id:PopupId;
    group?:PopupGroup;
    onDismissed?:OnPopupDismissedFn;
    isModal?:boolean;
    hasModalBackground?:boolean;
    position?:WindowPos;
    popupSource?:PopupSource;
    sourceAnchor?:SourceAnchor;
    popupAnchor?:PopupAnchor;
    popupSize?:PopupSize;
    className?:string;
    style?:React.CSSProperties;
    ignoreEsc?:boolean;
    disablePointerEvents?:boolean;
    stickToSource?:boolean;
}

export enum WindowPos
{
    CenterTop = 1,
    CenterMiddle = 2,
    CenterBottom = 3,
    LeftTop = 4,
    LeftMiddle = 5,
    LeftBottom = 6,
    RightTop = 7,
    RightMiddle = 8,
    RightBottom = 9
}

export enum SourceAnchor
{
    LeftBottom = 1,
    RightBottom = 2,
    CenterBottom = 3,
    LeftTop = 4,
    RightTop = 5,
    CenterTop = 6,
    LeftMiddle = 7,
    RightMiddle = 8,
    CenterMiddle = 9
}

export enum PopupAnchor
{
    LeftBottom = 1,
    RightBottom = 2,
    CenterBottom = 3,
    LeftTop = 4,
    RightTop = 5,
    CenterTop = 6,
    LeftMiddle = 7,
    RightMiddle = 8,
    CenterMiddle = 9
}

export enum PopupSize
{
    Original = 1,
    WidthOfSource = 2,
    HeightOfSource = 3,
    WidthAndHeightOfSource = 4
}

export interface IPopup
{
    getKind():PopupKind;
}

export interface IPopupManager
{
    registerPopup(popup:IPopup, props:IPopupProps):void;

    updatePopup(popup:IPopup, nextProps:IPopupProps):void;

    unregisterPopup(popup:IPopup):void;

    onPopupStackChanged(listener:PopupStackListener):IDisposable;

    onNonPopupItemClicked():void;

    onPopupItemClicked(itemWithIndex:PopupItemWithIndex):void;

    closeTopmostPopup();

    getPopupStack():Array<PopupItem>;

    findPopupItem(id:PopupId):PopupItemWithIndex;

    findPopupFromElement(elem:HTMLElement):PopupItemWithIndex;

    position(id:PopupId,
             sourceAnchor?:SourceAnchor,
             popupAnchor?:PopupAnchor,
             popupSize?:PopupSize):React.Ref<HTMLElement | SVGElement>;

    fixedPosition(id:PopupId,
                  popupSource:PopupSource,
                  sourceAnchor?:SourceAnchor,
                  popupAnchor?:PopupAnchor,
                  popupSize?:PopupSize):React.Ref<HTMLElement>
}
